import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { api, endpoints } from '../config/api';
import { authStorage } from '../utils/auth';
import { useConfig } from '../context/ConfigContext';
import { getAssetUrl } from '../config/assets';

function LoginPage() {
  const navigate = useNavigate();
  const { config } = useConfig();
  const mujerKvUrl = config?.mujerKvUrl || getAssetUrl('mujerKv');
  const logoMedicina = config?.welcomeLogos?.[0]?.url || getAssetUrl('logoMedicina');
  const logoHeel = config?.welcomeLogos?.[1]?.url || getAssetUrl('logoHeel');
  const [identifier, setIdentifier] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!identifier?.trim()) {
      setError('Ingresa tu nombre o cédula de ciudadanía');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post(endpoints.login(), { identifier: identifier.trim() });
      if (res.token && res.user) {
        authStorage.setToken(res.token);
        authStorage.setUser(res.user);
        navigate('/dashboard', { replace: true });
      } else {
        setError(res?.message || 'Error al iniciar sesión');
      }
    } catch (err) {
      setError(err?.message || err?.message || 'Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden pb-20">
      <div
        className="absolute inset-0 -z-10"
        style={{
          background: config?.bodyBackgroundImage
            ? `linear-gradient(180deg, rgba(15, 60, 50, 0.85) 0%, rgba(20, 80, 70, 0.75) 50%, rgba(25, 100, 90, 0.7) 100%), url(${config.bodyBackgroundImage}) center/cover`
            : 'linear-gradient(180deg, #0f3c32 0%, #145046 50%, #19645a 100%)',
        }}
      />

      <div className="relative z-0 flex flex-col flex-1 items-center justify-between px-4 pt-6">
        <div className="relative z-0 flex flex-col items-center justify-between px-4 pt-6 sm:pt-10">
          <div className="relative w-full overflow-hidden rounded-lg p-3 sm:p-4 flex items-center min-h-[180px] sm:min-h-[250px]">
            {config?.headerImage && (
              <div className="z-10 flex-1 min-w-0 pl-2 sm:pl-4 mr-12 sm:mr-20">
                <img src={config.headerImage} alt="37 Simposio" className="h-auto w-full max-w-[280px] sm:max-w-[326px] object-contain object-left" />
              </div>
            )}
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-center px-4 py-8 w-full max-w-sm mx-auto">
          <div className="bg-white/25 backdrop-blur-md border border-white/30 rounded-2xl p-6 shadow-xl">
            <h1 className="text-2xl font-bold text-white mb-2 text-center">Iniciar sesión</h1>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-white/90 mb-1">Nombre o Cédula de ciudadanía*</label>
                <input
                  type="text"
                  value={identifier}
                  onChange={(e) => setIdentifier(e.target.value)}
                  placeholder="Correo, cédula o nombre"
                  className="w-full px-4 py-3 rounded-xl border border-white/40 bg-white/20 text-white placeholder-white/60 focus:ring-2 focus:ring-white/50 focus:border-white/60"
                  autoComplete="username"
                  disabled={loading}
                />
              </div>
              {error && (
                <div className="bg-red-500/30 border border-red-400/50 rounded-xl p-3">
                  <p className="text-white text-sm">{error}</p>
                </div>
              )}
              <button
                type="submit"
                disabled={loading}
                className="w-full py-4 px-6 rounded-xl font-semibold text-center text-gray-800 bg-[#a3e635] hover:bg-[#bef264] transition-colors shadow-lg disabled:opacity-50"
              >
                {loading ? 'Ingresando...' : 'Ingresar'}
              </button>
            </form>
            <p className="mt-6 text-center text-sm text-white/80">
              ¿No tienes cuenta?{' '}
              <Link to="/registro" className="text-white font-semibold hover:underline">
                Regístrate
              </Link>
            </p>
          </div>
        </div>        
        
      </div>

      <div className="flex-1 z-20 flex justify-between items-end px-8 mt-12 py-8 pb-8 gap-8">
      {mujerKvUrl && (
              <div className="absolute right-14 mt-12 mr-7 bottom-51 h-full w-1/2 sm:w-1/4 flex justify-center items-end pointer-events-none">
                <img src={mujerKvUrl} alt="" className="h-[110%] sm:h-[120%] w-auto object-contain object-bottom mix-blend-screen brightness-110 opacity-80 sm:opacity-60" />
              </div>
            )}
        <div className="flex flex-col items-start gap-2 min-w-0 flex-1">
          {logoMedicina && (
            <img src={logoMedicina} alt="Medicina Biorreguladora de Sistemas" className="h-[110%] w-auto sm:h-20 object-contain object-left max-w-[75%]" />
          )}
        </div>
        <div className="flex items-end flex-shrink-0">
          {logoHeel && (
            <img src={logoHeel} alt="Heel" className="h-8 sm:h-10 object-contain" />
          )}
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
